'use strict';

angular.module('paizacloudApp')
  .directive('sidebar', function() {
    return {
      templateUrl: 'app/sidebar.directive/sidebar.directive.html',
      restrict: 'EA',
      scope: {
        container: '=',
        windowModels: '=',
        active: '=',
        deleteWindowModel: '&',
        onSelectNode: '&',
      },
      link: function(scope, element, attrs) {
        scope.prevActive = scope.active;
        scope.prevActive = null;
        scope.tabClick = function(index){
          console.log('sidebar:tabClick');
          if(index === scope.prevActive){
            scope.active = null;
          }
          scope.prevActive = index;
        };
        scope.delete = function(windowModel){
          console.log('sidebar:delete');
          scope.deleteWindowModel({$windowModel: windowModel});
        };
      },
      controller: function($scope){
        this.scope = $scope;
      },
    };
  });
